import React from 'react'
import { Loader } from '@/tumeloshared'

export const LoadingForm: React.FC = () => <Loader />
